import { render, staticRenderFns } from "./ProformaStaffCard.vue?vue&type=template&id=0c28b684&"
import script from "./ProformaStaffCard.vue?vue&type=script&lang=js&"
export * from "./ProformaStaffCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports